const colors = [
  "#8083DC",
  "#85DB52",
  "#D980F8",
  "#6DC9D7",
  "#EF8A7F",
  "#EBBF51",
  "#6467D4",
  "#D571F8",
  "#61C2D1",
  "#79D746",
  "#E9B744",
  "#EE7C70",
  "#494ACB",
  "#D162F7",
  "#58BCCC",
  "#E6AF3C",
  "#6FD33F",
  "#ED6E60",
  "#3936B5",
  "#B425EF",
  "#49A2B3",
  "#E18E33",
  "#4FAD32",
  "#E45C48",
];

export const pickColorById = (id: number): string => {
  const colorIndex = id % colors.length;
  return colors[colorIndex] ?? "#8083DC";
};
